import { render } from "./ProjectSingle.vue?vue&type=template&id=8d4a8a46&scoped=true"
import script from "./ProjectSingle.vue?vue&type=script&lang=js"
export * from "./ProjectSingle.vue?vue&type=script&lang=js"

import "./ProjectSingle.vue?vue&type=style&index=0&id=8d4a8a46&scoped=true&lang=css"

import exportComponent from "/dev/shm/repo/portfolio-dp7mkww8fwx8/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d4a8a46"]])

export default __exports__